import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Lock, CreditCard, CheckCircle } from 'lucide-react';
import PaymentModal from './PaymentModal';

const PaymentGate = ({ profile, sectionName = 'this section' }) => {
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="p-6 lg:p-8"
    >
      <div className="max-w-2xl mx-auto">
        <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg border-2 border-dashed border-gray-300 p-8 text-center">
          <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-4">
            <Lock className="text-gray-500" size={32} />
          </div>
          
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Complete Your Application Journey
          </h2>
          
          <p className="text-gray-600 mb-3">
            Unlock document uploads and personalized SOP assistance
          </p>

          <p className="text-gray-700 text-xs mb-6">
            We'll manage your complete application from start to finish, beginning the moment you unlock access. Share your documents and story with us, and we'll craft a compelling Statement of Purpose that highlights your unique strengths and aspirations. Through our direct relationships with academic institutions, we understand what each admissions committee is looking for and will position your application accordingly.
          </p>

          <div className="bg-white rounded-lg p-6 mb-6 border border-gray-200">
            <div className="flex items-center justify-between mb-4">
              <span className="text-gray-700 font-medium">One-time Payment</span>
              <span className="text-3xl font-bold text-[#202356]">$149</span>
            </div>
            
            <div className="space-y-3 text-left">
              <div className="flex items-center gap-3">
                <CheckCircle className="text-green-600 flex-shrink-0" size={14} />
                <span className="text-xs text-gray-700">Upload documents to start your application</span>
              </div>
              <div className="flex items-center gap-3">
                <CheckCircle className="text-green-600 flex-shrink-0" size={14} />
                <span className="text-xs text-gray-700">We'll create your expert SOP</span>
              </div>
              <div className="flex items-center gap-3">
                <CheckCircle className="text-green-600 flex-shrink-0" size={14} />
                <span className="text-xs text-gray-700">Benefit from our institutional insights</span>
              </div>
            </div>
          </div>

          <button
            onClick={() => setShowPaymentModal(true)}
            className="bg-[#202356] hover:bg-[#2542D4] text-white font-semibold px-8 py-3 rounded-lg transition-colors flex items-center gap-2 mx-auto"
          >
            <CreditCard size={20} />
            <span>Unlock Now - Pay $149</span>
          </button>

          <p className="text-xs text-gray-500 mt-4">
            Secure payment powered by Stripe
          </p>
        </div>
      </div>

      {/* Payment Modal */}
      <PaymentModal 
        isOpen={showPaymentModal}
        onClose={() => setShowPaymentModal(false)}
      />
    </motion.div>
  );
};

export default PaymentGate;
